import { observer } from 'mobx-react';

import { useContextModal } from '@/components/Modal';
import { useUpdateVenueRemark } from '@/services';

import { ConfirmDialog } from './ConfirmDialog';
import VenueRemarkInfoView from './VenueRemarkInfoView';

interface VenueRemarkInfoProps {
  onClose: () => void;
}

const getVenueId = () => {
  const pathArr = location.pathname.split('/');
  return Number(pathArr[pathArr.length - 1]);
};

export default observer(function VenueRemarkInfoContainer(
  props: VenueRemarkInfoProps
) {
  const { onClose } = props;
  const vid = getVenueId();
  const modal = useContextModal();

  const { mutate: updateVenueRemark, isLoading: isUpdating } =
    useUpdateVenueRemark(
      vid,
      function onSuccess(data) {
        modal.open([
          <ConfirmDialog onClose={modal.close} />,
          { size: 'auto', isOverlayClickable: false },
        ]);
      },
      function onError(err) {
        console.log(err);
      }
    );
  return (
    <VenueRemarkInfoView
      isUpdating={isUpdating}
      handleSave={updateVenueRemark}
      onClose={onClose}
    />
  );
});
